import React from "react";
import { CheckCheck, Clock3 } from "lucide-react";

import { chatText } from "../messages";
import { TransferReviewCard } from "./TransferReviewCard";

export function MessageBubble({
  message,
  onRetry,
}) {
  if (!message) {
    return null;
  }

  const isUser =
    message.sender === "user";

  const showTransferCard =
    [
      "transfer_draft",
      "transfer_ready",
      "quote",
    ].includes(message.kind) &&
    (message.transfer || message.quote);

  return (
    <div
      className={`flex w-full ${
        isUser
          ? "justify-end"
          : "justify-start"
      }`}
    >
      <div
        className={
          showTransferCard
            ? "w-full max-w-[430px]"
            : `max-w-[82%] rounded-2xl px-4 py-2.5 shadow-sm ${
                isUser
                  ? "rounded-br-md bg-[#C0F6B7] text-[#0A2540]"
                  : "rounded-bl-md border border-black/[0.03] bg-[#F5F2EB] text-[#0A2540]"
              }`
        }
      >
        {showTransferCard ? (
          <>
            {message.text && (
              <div className="mb-2 inline-block rounded-2xl rounded-bl-md bg-[#F5F2EB] px-4 py-2.5 text-sm leading-5 text-[#0A2540] shadow-sm">
                {message.text}
              </div>
            )}

            <TransferReviewCard
              transfer={message.transfer}
              quote={message.quote}
            />
          </>
        ) : (
          <>
            <p className="whitespace-pre-wrap text-sm leading-5">
              {message.text}
            </p>

            {isUser && message.status !== "failed" && (
              <div className="mt-1 flex justify-end">
                {message.status === "sending" ? (
                  <Clock3
                    size={13}
                    className="text-[#0A4730]/40"
                  />
                ) : (
                  <CheckCheck
                    size={13}
                    className="text-[#0A4730]/50"
                  />
                )}
              </div>
            )}

            {isUser && message.status === "failed" && (
              <div className="mt-1 flex items-center justify-end gap-2 text-xs text-[#9B1C1C]">
                <span>
                  {message.errorText ||
                    chatText("chat.message.failed")}
                </span>
                {message.retryable !== false && onRetry && (
                  <button
                    type="button"
                    onClick={() => onRetry(message)}
                    className="font-semibold underline"
                  >
                    {chatText("chat.message.retry")}
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}